export default value => RegExp("[A-Z]").test(value);
